"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = RetirementIncomeGapTransportationModal;
var _react = _interopRequireWildcard(require("react"));
var _formik = require("formik");
var _reactBlueprintLibrary = require("react-blueprint-library");
var _RetirementIncomeGapTransportationModalFormControls = require("./RetirementIncomeGapTransportationModalFormControls");
var _utils = require("../../middleware/utils");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function RetirementIncomeGapTransportationModal(_ref) {
  var {
    show,
    handleClose,
    snapshot,
    transportationHandleSubmit
  } = _ref;
  // Pulling formik context from higher up, which gives us access to formik state
  var {
    values,
    errors,
    touched,
    setFieldValue,
    isSubmitting,
    isValid
  } = (0, _formik.useFormikContext)();
  var handleSubmit = e => {
    e.preventDefault();
    transportationHandleSubmit();
    setFieldValue('transportation_modalHasBeenOpened', true);
  };
  (0, _react.useEffect)(() => {
    var sum = (0, _utils.ifNanReturn0)((0, _utils.parseCurrencyString)(null, values.transportation_automobilePayments)) + (0, _utils.ifNanReturn0)((0, _utils.parseCurrencyString)(null, values.transportation_carInsurance)) + (0, _utils.ifNanReturn0)((0, _utils.parseCurrencyString)(null, values.transportation_carMaintenance)) + (0, _utils.ifNanReturn0)((0, _utils.parseCurrencyString)(null, values.transportation_transport)) + (0, _utils.ifNanReturn0)((0, _utils.parseCurrencyString)(null, values.transportation_gas)) + (0, _utils.ifNanReturn0)((0, _utils.parseCurrencyString)(null, values.transportation_otherExpenses));
    setFieldValue('temp_transportationAndInsuranceCost', sum);
  }, [values.transportation_automobilePayments, values.transportation_carInsurance, values.transportation_carMaintenance, values.transportation_transport, values.transportation_gas, values.transportation_otherExpenses]);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Modal, {
    size: "md",
    show: show
  }, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Modal.Header, {
    onClose: () => handleClose(snapshot),
    title: "Monthly Transportation Expenses"
  }), /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Modal.Body, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "container"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "row"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "col-12"
  }, /*#__PURE__*/_react.default.createElement(_RetirementIncomeGapTransportationModalFormControls.AutomobilePayments, {
    errors: errors,
    touched: touched,
    values: values,
    setFieldValue: setFieldValue
  }), /*#__PURE__*/_react.default.createElement(_RetirementIncomeGapTransportationModalFormControls.CarInsurance, {
    errors: errors,
    touched: touched,
    values: values,
    setFieldValue: setFieldValue
  }), /*#__PURE__*/_react.default.createElement(_RetirementIncomeGapTransportationModalFormControls.CarMaintenance, {
    errors: errors,
    touched: touched,
    values: values,
    setFieldValue: setFieldValue
  }), /*#__PURE__*/_react.default.createElement(_RetirementIncomeGapTransportationModalFormControls.Transport, {
    errors: errors,
    touched: touched,
    values: values,
    setFieldValue: setFieldValue
  }), /*#__PURE__*/_react.default.createElement(_RetirementIncomeGapTransportationModalFormControls.Gas, {
    errors: errors,
    touched: touched,
    values: values,
    setFieldValue: setFieldValue
  }), /*#__PURE__*/_react.default.createElement(_RetirementIncomeGapTransportationModalFormControls.OtherExpenses, {
    errors: errors,
    touched: touched,
    values: values,
    setFieldValue: setFieldValue
  }), /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement("div", {
    className: "eyebrow"
  }, "TOTAL MONTHLY TRANSPORTATION EXPENSES"), /*#__PURE__*/_react.default.createElement("div", {
    className: "data-md"
  }, "$", ' ', (0, _utils.numberToString)(values.temp_transportationAndInsuranceCost ? values.temp_transportationAndInsuranceCost : 0)), /*#__PURE__*/_react.default.createElement("div", {
    className: "invalidFeedBack invalid-message-color"
  }, errors.temp_transportationAndInsuranceCost ? errors.temp_transportationAndInsuranceCost : ''))))), /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Modal.Footer, null, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Button, {
    variant: "link",
    onClick: () => handleClose(snapshot)
  }, "Cancel"), /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Button, {
    disabled: isSubmitting || !isValid,
    onClick: handleSubmit
  }, "Update"))));
}